export default "__VITE_ASSET__b58d4653__"